import { useQuery } from '@tanstack/react-query';
import { fetchPractiseAdminRoleManagementList } from './helper';

export const usePractiseAdminRoleManagementList = (
  role: string,
  roleAssigned: string,
  enabled: boolean
) => {
  return useQuery({
    queryKey: ['practise-admin-role-management-list', roleAssigned, role],
    queryFn: () => fetchPractiseAdminRoleManagementList(roleAssigned, role),
    enabled
  });
};
